package com.nonopn.skydome.common.app.pages.main.view.map

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skydome.common.app.pages.main.model.FakeMainScreenModel
import com.nonopn.skydome.common.app.pages.main.model.MainScreenModel
import compose.icons.WeatherIcons
import compose.icons.weathericons.Lightning
import de.drick.compose.hotpreview.HotPreview

@Composable
fun CounterLightning(
    modifier: Modifier,
    model: MainScreenModel
) {
    val states by model.states.collectAsState()
    CounterDefault(
        modifier,
        rememberVectorPainter(WeatherIcons.Lightning),
        "${states.visibleLightningActivity}"
    ) {
        model.openLightningDrawer()
    }
}

@Composable
@HotPreview(widthDp = 150, heightDp = 50, darkMode = true)
@HotPreview(widthDp = 150, heightDp = 50, darkMode = false)
private fun CounterUsersPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        CounterLightning(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(false)
        )
    }
}
